export default new WeakMap();
//# sourceMappingURL=instances.js.map